import { InlineCode } from '@sparkpost/matchbox';

/**
 * Matchbox InlineCode component
 * @see https://design.sparkpost.com/components/inlinecode/
 */
export default InlineCode;
